<template>
  <div v-if="infocard">
    <infocard-base-form v-model="infocard" />
    <b-row>
      <b-col cols="7">
        <b-form-group :label="T('Web.Generic.Infocards.Collector') + ' *'">
          <infocard-collector-picker v-model="infocard.collectorId" />
        </b-form-group>
      </b-col>
      <b-col cols="5">
        <b-form-group :label="T('Web.Generic.Infocards.InternalGroupId')">
          <b-form-input v-model="infocard.internalGroupId" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group :label="T('Web.Generic.Infocards.SupplierIdRefNumber')">
          <b-form-tags v-model="infocard.supplierIdRefNumber" input-id="tags-basic" :placeholder="T('Web.Generic.Add') + ' ' + T('Web.Generic.Infocards.SupplierIdRefNumber')" :addButtonText="T('Web.Generic.Add')" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="4">
        <b-form-group :label="T('Web.Generic.Price', 'Price') + ' *'">
          <b-form-input 
            v-model="infocard.price" 
            type="number" 
            step="0.01" 
            min="0" 
            required 
          />
        </b-form-group>
      </b-col>
      <b-col cols="3">
        <b-form-group :label="T('Web.Generic.Quantity', 'Quantity')">
          <b-form-input 
            v-model="infocard.quantity" 
            type="number" 
            min="1"
          />
        </b-form-group>
      </b-col>
      <b-col cols="5">
        <b-form-group :label="T('Web.Generic.Note', 'Note')">
          <b-form-input v-model="infocard.note" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12">
        <b-form-group :label="T('Web.Generic.Infocards.IsOrderable', 'Is Orderable')">
          <b-form-checkbox
            v-model="infocard.isOrderable"
            :value="true"
            :unchecked-value="false"
            switch
            size="lg"
          >
          </b-form-checkbox>
        </b-form-group>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InfocardBaseForm from "./InfocardBaseForm.vue";
import InfocardCollectorPicker from "./InfocardCollectorPicker.vue";
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormTags,
  BFormCheckbox,
} from "bootstrap-vue";

export default {
  components: {
    InfocardBaseForm,
    InfocardCollectorPicker,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormTags,
    BFormCheckbox,
  },
  props: {
    infocard: {
      required: true,
    },
  },
  mounted() {
    this.initializeDefaults();
    this.$emit("submittable-status-changed", this.submittable);
  },
  computed: {
    submittable() {
      return (
        this.valueIsNotEmptyOrUnknown(this.infocard.name) &&
        this.valueIsNotEmptyOrUnknown(this.infocard.locationId) &&
        this.valueIsNotEmptyOrUnknown(this.infocard.collectorId) &&
        this.valueIsNotEmptyOrUnknown(this.infocard.price) &&
        this.infocard.price > 0
      );
    },
  },
  methods: {
    initializeDefaults() {
      if (!this.infocard.quantity) {
        this.infocard.quantity = 1;
      }
      if (this.infocard.isOrderable === undefined) {
        this.infocard.isOrderable = true;
      }
    },
  },
  watch: {
    submittable(newValue) {
      this.$emit("submittable-status-changed", newValue);
    },
  },
};
</script>